import "./style.scss";
import { FC } from "react";
import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocMaltaWithPrint from "@/src/assets/admissionOfficePage/back-for-doc-malta-with-print.webp";
import backForDocMaltaWithoutPrint from "@/src/assets/admissionOfficePage/back-for-doc-malta-without-print.webp";
import { AOPMaltaStudentData } from "@/src/types/admissionOffice";
import type { StudentLetterBasicCountry } from "../studentLetterBasicRegistry";

interface AOPPrevProps {
  country: StudentLetterBasicCountry;
  bodyForPrev: AOPMaltaStudentData;
  customize: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev, customize }) => {
  if (customize) {
    return (
      <div className="admission-office-prev-wrapper">
        <div className={`admission-office-prev ${country} student-letter`}>
          <img className="admission-office-prev-background" src={backForDocMaltaWithoutPrint} alt="" />
          <div className="admission-office-prev-section title">STUDENT LETTER</div>
          <div className="admission-office-prev-section number-and-date">
            <span>№ - </span>
            <span>Date: {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
          </div>
          <div className="admission-office-prev-section-file">
            {bodyForPrev.file && (
              <img src={URL.createObjectURL(bodyForPrev.file)} alt="" className="admission-office-prev-photo" />
            )}
          </div>
          <div className="admission-office-prev-section info">
            <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
            <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
            <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
            <p>Degree Program: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
            <p>Pasport Number: {bodyForPrev.passportNumber ? bodyForPrev.passportNumber : ""}</p>
            <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
            <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
            <p>Academic Year: {bodyForPrev.academicYear ? bodyForPrev.academicYear : ""}</p>
            <p>Year of Study: {bodyForPrev.yearOfStudy ? bodyForPrev.yearOfStudy : ""}</p>
            <p>Year Study Mode: {bodyForPrev.yearStudyMode ? bodyForPrev.yearStudyMode : ""}</p>
          </div>
          {bodyForPrev.bodyStudentLetter ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.bodyStudentLetter.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
        <div className={`admission-office-prev ${country} student-letter`}>
          <img className="admission-office-prev-background" src={backForDocMaltaWithoutPrint} alt="" />
          <div className="admission-office-prev-section title">STUDENT LETTER</div>
          <div className="admission-office-prev-section number-and-date">
            <span>№ - </span>
            <span>Date: {bodyForPrev.secondPageDate ? bodyForPrev.secondPageDate : "-"}</span>
          </div>
          <div className="admission-office-prev-section-file">
            {bodyForPrev.file && (
              <img src={URL.createObjectURL(bodyForPrev.file)} alt="" className="admission-office-prev-photo" />
            )}
          </div>
          <div className="admission-office-prev-section info">
            <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
            <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
            <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
            <p>Degree Program: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
            <p>Pasport Number: {bodyForPrev.passportNumber ? bodyForPrev.passportNumber : ""}</p>
            <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
            <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
            <p>Academic Year: {bodyForPrev.academicYear ? bodyForPrev.academicYear : ""}</p>
            <p>Year of Study: {bodyForPrev.yearOfStudy ? bodyForPrev.yearOfStudy : ""}</p>
            <p>Year Study Mode: {bodyForPrev.yearStudyMode ? bodyForPrev.yearStudyMode : ""}</p>
          </div>
          {bodyForPrev.secondBodyStudentLetter ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.secondBodyStudentLetter.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
        <div className={`admission-office-prev ${country} student-letter`}>
          <img className="admission-office-prev-background" src={backForDocMaltaWithPrint} alt="" />
          {bodyForPrev.thirdBodyStudentLetter ? (
            <div className="admission-office-prev-section body-content third">
              {bodyForPrev.thirdBodyStudentLetter.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} student-letter`}>
        <img className="admission-office-prev-background" src={backForDocMalta} alt="" />
        <div className="admission-office-prev-section title">STUDENT LETTER</div>
        <div className="admission-office-prev-section number-and-date">
          <span>№ - </span>
          <span>Date: {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
        </div>
        <div className="admission-office-prev-section-file">
          {bodyForPrev.file && (
            <img src={URL.createObjectURL(bodyForPrev.file)} alt="" className="admission-office-prev-photo" />
          )}
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
          <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
          <p>Degree Program: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
          <p>Pasport Number: {bodyForPrev.passportNumber ? bodyForPrev.passportNumber : ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
          <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
          <p>Academic Year: {bodyForPrev.academicYear ? bodyForPrev.academicYear : ""}</p>
          <p>Year of Study: {bodyForPrev.yearOfStudy ? bodyForPrev.yearOfStudy : ""}</p>
          <p>Year Study Mode: {bodyForPrev.yearStudyMode ? bodyForPrev.yearStudyMode : ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>Head of Foreign Students department</p>
          <p>Fedorova Anzhelika</p>
          <p>International European University</p>
        </div>
        {bodyForPrev.bodyStudentLetter ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.bodyStudentLetter.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
